import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, Validators} from '@angular/forms';
import {WizardFormEventsService} from '../wizard-form-events.service';
import {WizardValidators} from '../../wizard-validators';
import {filter, map, takeUntil} from 'rxjs/operators';
import {WizardEnums} from '../../../wizard.namespace';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';

@Injectable()
export class ConclusionsService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        applicant_name: ['', [
            WizardValidators.withoutSymbols('имени заявителя'),
            WizardValidators.required('Заявитель')
        ]],

        applicant_job: ['', [
            WizardValidators.withoutSymbols('должности заявителя'),
            WizardValidators.required('Должность заявителя')
        ]],

        date: ['', [
            WizardValidators.required('Дата создания лаборатории'),
            WizardValidators.date(),
        ]],

        order_number: ['', WizardValidators.required('Номер приказа')],

        order_date: ['', [
            WizardValidators.required('Дата приказа создания лаборатории'),
            WizardValidators.date(),
        ]],

        passport_developer_name: ['', [
            WizardValidators.withoutSymbols('имени разработчика паспорта'),
            WizardValidators.required('Разработчик паспорта')
        ]],

        passport_developer_job: ['', [
            WizardValidators.withoutSymbols('должности разработчика паспорта'),
            WizardValidators.required('Должность разработчика паспорта')
        ]],

        docs_developer_name: ['', [
            WizardValidators.withoutSymbols('имени разработчика документов'),
            WizardValidators.required('Разработчик')
        ]],

        docs_developer_job: ['', [
            WizardValidators.withoutSymbols('должности разработчика документов'),
            WizardValidators.required('Должность разработчика')
        ]],
    });

    constructor(
        private fb: FormBuilder,
        private wizardFormEvents: WizardFormEventsService,
        private specialistsProvider: SpecialistsProvider,
    ) {
        super();
    }

    init() {
        this.wizardFormEvents.laboratoryAttestationType$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((type) => {
            if (+type === WizardEnums.LaboratoryAttestationTypes.existed) {
                this.form.get('order_number').patchValue('');
                this.form.get('order_number').disable();
                this.form.get('order_date').patchValue('');
                this.form.get('order_date').disable();
            } else {
                this.form.get('order_number').enable();
                this.form.get('order_date').enable();
            }
        });

        if (this.isFormTouched()) {
            return;
        }

        this.wizardFormEvents.organizationOwnerName$.pipe(
            takeUntil(this.stopSubscribe$)
        ).subscribe(name => {
            this.form.get('applicant_name').patchValue(name);
        });

        this.wizardFormEvents.organizationOwnerJob$.pipe(
            takeUntil(this.stopSubscribe$)
        ).subscribe(job => {
            this.form.get('applicant_job').patchValue(job);
        });

        this.wizardFormEvents.laboratoryLeaderId$.pipe(
            filter(v => {
                const isValue = Boolean(v);
                if (!isValue) {
                    this.setPassportDeveloperValues('', '');
                }
                return isValue;
            }),
            map((id) => this.specialistsProvider.getById(+id)),
            filter(v => {
                const isValue = Boolean(v);
                if (!isValue) {
                    this.setPassportDeveloperValues('', '');
                }
                return isValue;
            }),
            takeUntil(this.stopSubscribe$)
        ).subscribe((specialist: SpecialistViewInterface) => {
            this.setPassportDeveloperValues(specialist.full_name, specialist.job_title);
        });

        this.form.get('_touched').valueChanges.pipe(
            filter(v => Boolean(v)),
            takeUntil(this.stopSubscribe$)
        ).subscribe(() => {
            this.stopSubscribe$.next();
        });
    }

    restoreValidators() {

    }

    private setPassportDeveloperValues(name: string = '', job: string = '') {
        this.form.get('passport_developer_name').patchValue(name);
        this.form.get('passport_developer_job').patchValue(job);
    }
}
